import { cn } from "@/domains/library"
import { TokenIcon } from "@/domains/tokens/components/token-icon"

export type ITokenInputSymbol = {
  symbol: string
  imageURL: string
}

export const TokenInputSymbol = ({
  token,
  className,
  size,
}: {
  token: ITokenInputSymbol | null | undefined
  className?: string
  size?: number
}) => {
  if (!token) {
    return null
  }

  return (
    <div className="flex flex-row items-center gap-1.5 py-2">
      <TokenIcon token={token} size={size ?? 24} />
      <div className={cn("text-t200 font-medium leading-6", className)}>{token.symbol}</div>
    </div>
  )
}
